let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("illQN")).then(() => parcelRequire('iIrS6'));